define('controller/step/datetime/FlexibleDateTimeStep',['require','controller/step/datetime/BaseDateTimeStep','collection/TimeFlexibleCollection','view/controller/booking/datetime/flexible/TimeFlexibleView'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var TimeFlexibleCollection = require('collection/TimeFlexibleCollection');
    var TimeFlexibleView = require('view/controller/booking/datetime/flexible/TimeFlexibleView');

    return BaseDateTimeStep.extend({

        _timeCollection: null,

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new TimeFlexibleCollection();
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var view = new TimeFlexibleView({
                model: this._bookingModel,
                bookingModel: this._bookingModel,
                calendarCollection: this._calendarCollection,
                timeCollection: this._timeCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });

            this.listenTo(view, 'timeChanged', this._updateSelectedTime);

            return view;
        }

    });

});
